/**
 * PostHog runs only in production-style deployments (not localhost / dev server).
 */
export function shouldRecordPostHog() {
  if (typeof window === "undefined") return false;
  if (process.env.NODE_ENV === "development") return false;
  const host = window.location.hostname;
  if (host === "localhost" || host === "127.0.0.1") return false;
  return true;
}
